import React from 'react'
import * as Filters from 'support/filters'
import ConstrainScheduleToRoute from 'widgets/shifts/ConstrainScheduleToRoute'
import { Model, TriggerPipelineOnOperationExecute, WhenModel, WhenModelValue } from '@morningtrain/react-resources'
import { Pipeline } from '@morningtrain/react-helpers'
import PushScheduleToHistoryOnPipe from 'widgets/shifts/PushScheduleToHistoryOnPipe'
import { MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import SchedulePeriodSummarySmartview from 'widgets/smartviews/shifts/SchedulePeriodSummarySmartview'
import ReadSchedule from 'widgets/shifts/ReadSchedule'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import * as Displays from 'support/displays'

export default function FetchSchedule ({ mode = 'view', actions = null, children, titleTransName = null }) {
  return (
    <Model resourceName='shifts.schedule' operationName='fetch' autoFetch={false}>
      <Filters.SelectedDepartmentFilter />
      <ConstrainScheduleToRoute />

      <Pipeline>
        <TriggerPipelineOnOperationExecute />
        <PushScheduleToHistoryOnPipe />
        {mode === 'view' ? null : <MountSmartviewWithModelOnPipe smartview={<SchedulePeriodSummarySmartview />} />}
      </Pipeline>

      <UI.PageHeader title={(
        <>
          <TranslatedTitle name={titleTransName || (mode === 'view' ? 'shifts.view.title' : 'shifts.planner.title')} />
          <WhenModelValue name='department_name'>
            <span> - </span>
            <Displays.Text name='department_name' />
          </WhenModelValue>
        </>
      )}
      >
        <div className='flex items-center group space-x-3'>
          {actions}
          <Filters.EmploymentCategoryFilterSyncedWithModel
            name='category'
            iconMap={{
              kitchen: <UI.Icons.Chef />,
              waiter: <UI.Icons.Plates />
            }}
          />
          <Filters.WeekFilterSyncedWithModel name='week' />
        </div>
      </UI.PageHeader>

      <WhenModel>
        <ReadSchedule>
          {children}
        </ReadSchedule>
      </WhenModel>
    </Model>
  )
}
